export const CONSOLIDATED_DASHBOARD_ROLE_NAME = 'Consolidated Dashboard';
